<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="医院名称" prop="hospitalId">
                <a-input v-model="queryParam.hospitalName" placeholder="请输入医院名称" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="变动类型" prop="changeType">
                <a-select placeholder="请选择变动类型" v-model="queryParam.changeType" style="width: 100%" allow-clear>
                  <!-- 优化：使用value的原始类型，避免类型转换问题 -->
                  <a-select-option v-for="(d, index) in dict.type.change_type" :key="index" :value="d.value">{{ d.label }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="变动场景" prop="changeScene">
                <a-select placeholder="请选择变动场景" v-model="queryParam.changeScene" style="width: 100%" allow-clear>
                  <!-- 优化：使用value的原始类型，避免类型转换问题 -->
                  <a-select-option v-for="(d, index) in dict.type.change_scene" :key="index" :value="d.value">{{ d.label }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="创建时间">
                <a-range-picker style="width: 100%" v-model="dateRange" valueFormat="YYYY-MM-DD" format="YYYY-MM-DD" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="handleExport" v-hasPermi="['hospital:scoreRecord:export']">
          <a-icon type="download" />导出
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        :changeTypeOptions="dict.type.change_type"
        :changeSceneOptions="dict.type.change_scene"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="changeType" slot-scope="text, record">
          <dict-tag :options="dict.type['change_type']" :value="record.changeType"/>
        </span>

        <span slot="changeScene" slot-scope="text, record">
          <dict-tag :options="dict.type['change_scene']" :value="record.changeScene"/>
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="updateTime" slot-scope="text, record">
          {{ parseTime(record.updateTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['hospital:scoreRecord:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['hospital:scoreRecord:edit']">
            <a-icon type="edit" />修改
          </a>
          <a-divider type="vertical" v-hasPermi="['hospital:scoreRecord:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['hospital:scoreRecord:remove']">
            <a-icon type="delete" />删除
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageScoreRecord, listScoreRecord, delScoreRecord } from '@/api/hospital/scoreRecord'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'ScoreRecord',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  // 确保字典类型正确声明，和参考代码一致
  dicts: ['change_type', 'change_scene'],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      advanced: false,
      single: true,
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      dateRange: [],
      // 查询参数优化：补充缺失的字段，和搜索框对应
      queryParam: {
        id: null,
        hospitalId: null,
        hospitalName: undefined, // 新增：对应医院名称搜索框
        changeType: null,
        beforeScore: null,
        score: null,
        afterScore: null,
        changeScene: null,
        creator: null,
        modifier: null,
        createTime: null,
        updateTime: null,
        isDeleted: null,
        remark: null,
        version: null,
        beginTime: null, // 新增：日期范围开始时间
        endTime: null,   // 新增：日期范围结束时间
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '医院名称',
          dataIndex: 'hospitalName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '变动场景',
          dataIndex: 'changeSceneStr',
          // scopedSlots: { customRender: 'changeScene' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '变动类型',
          dataIndex: 'changeTypeStr',
          // scopedSlots: { customRender: 'changeType' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '变动前华歧系数',
          dataIndex: 'beforeScore',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '变动华歧系数',
          dataIndex: 'score',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '变动后华歧系数',
          dataIndex: 'afterScore',
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '创建人',
        //   dataIndex: 'creator',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    // 确保字典加载完成后再获取列表数据
    this.$nextTick(() => {
      this.getList()
    })
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查询医院华歧系数变动记录列表 */
    getList () {
      this.loading = true
      // 优化：日期范围判断更严谨
      if (Array.isArray(this.dateRange) && this.dateRange.length === 2) {
        this.queryParam.beginTime = this.dateRange[0] + ' 00:00:00'
        this.queryParam.endTime = this.dateRange[1] + ' 23:59:59'
      } else {
        // 清空无效的日期参数
        this.queryParam.beginTime = null
        this.queryParam.endTime = null
      }
      pageScoreRecord(this.queryParam).then(response => {
        this.list = response.data.records || []
        this.total = response.data.total || 0
        this.loading = false
      }).catch(() => {
        // 异常处理：避免loading一直显示
        this.list = []
        this.total = 0
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },

    /** 重置按钮操作 */
    resetQuery () {
      this.dateRange = []
      this.queryParam = {
        id: undefined,
        hospitalId: undefined,
        hospitalName: undefined, // 重置医院名称
        changeType: undefined,
        beforeScore: undefined,
        score: undefined,
        afterScore: undefined,
        changeScene: undefined,
        creator: undefined,
        modifier: undefined,
        createTime: undefined,
        updateTime: undefined,
        isDeleted: undefined,
        remark: undefined,
        version: undefined,
        beginTime: undefined,    // 重置日期参数
        endTime: undefined,      // 重置日期参数
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },

    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },

    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },

    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },

    toggleAdvanced () {
      this.advanced = !this.advanced
    },

    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delScoreRecord(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success('删除成功', 3)
            })
        },
        onCancel () {
          that.ids = []
        }
      })
    },

    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('hospital/scoreRecord/export', {
            ...that.queryParam
          }, `医院华歧系数变动记录_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>